import axios from 'axios'
import { CDP_API_URL } from '../utils/Constants'

export default axios.create({
    baseURL: `${CDP_API_URL}`,
    headers: {
        'Content-type': 'charset=utf-8',
        'Access-Control-Allow-Origin': '*'
    }
})

const uniqueId = () => {
    let requestID = ''
    const storedID = localStorage.getItem('myID')
    if (storedID) {
        requestID = storedID
    } else {
        const newID = Math.floor(Math.random() * 16777216).toString(16).padStart(6, '0') + '_' + new Date().getTime()
        requestID = newID
        localStorage.setItem('myID', newID)
    }
    return requestID
}

export const headers = {
        'Content-Type': 'application/json',
        'request-id': uniqueId()
}

export const callSaveAPI = async (endPoint, params) => {
    try {
        const res = await axios.post(`${CDP_API_URL}/${endPoint}`, params, { headers: headers })
        const contentType = res ? res.headers['content-type'] : {}
        if (contentType && contentType.indexOf('application/json') > -1) {
            return res
        } else {
            console.error('Unexpected Content Type')
            return null
        }
    } catch {
        console.error('Error in API')
        return null
    }
}
